import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
  state: { 
    reward_advertisers: [],
    reward_being_edited: null,
    endpoints: {
      rewardDetail: 'https://stormy-mountain-29119.herokuapp.com/v3/obtain_reward/',
      addReward: 'https://stormy-mountain-29119.herokuapp.com/v3/add_reward/',
      updateReward: 'https://stormy-mountain-29119.herokuapp.com/v3/update_reward/',
      updateRewardLiveStatus: 'https://stormy-mountain-29119.herokuapp.com/v3/update_reward_live_status/',
      updateRewardArchivedStatus: 'https://stormy-mountain-29119.herokuapp.com/v3/update_reward_archived_status/',
    },
  },
  mutations,
  actions,
  getters,
}